export enum ParsingMethodType {
  Payin = 'payin',
  Payout = 'payout',
  Technical = 'technical',
  Spam = 'spam',
  Blocked = 'blocked',
}
